import React from 'react';
import PropTypes from 'prop-types';

import styles from './admins.module.scss';
import { config } from '../../api/config';
import {
  Checkbox,
  Input,
  MultiselectAll,
  Select,
  SubmitActions,
  Toggle,
  WithSpinner,
} from '../../components';
import { businessRoles } from './admins.data';
import {
  areAllPermissionsSelected,
  isPermissionSelected,
} from './admins.helpers';

const Form = ({
  type,
  values,
  onChange,
  onSubmit,
  loading,
  permissionDefinitions,
  selectedPermissions,
  onPermissionChange,
  onSelectAllPermissions,
  assignableLocations,
  assignableLocationsLoading,
  selectedLocationIds,
  allLocationsSelected,
  onLocationIdsChange,
  locationEmailNotificationEnabled,
  onLocationNotificationChange,
  locationSmsNotificationEnabled,
  onLocationSmsNotificationChange,
}) => {
  const renderLocationAccess = () => {
    return (
      <div className={styles.locationAccess}>
        <WithSpinner loading={assignableLocationsLoading}>
          <div className={styles.locationListWrapper}>
            {assignableLocations.length ? (
              <div className={styles.locationList}>
                <MultiselectAll
                  array={assignableLocations}
                  type="object"
                  name="label"
                  value="id"
                  valueType="number"
                  allText="Visi"
                  state={allLocationsSelected ? [] : selectedLocationIds}
                  setState={onLocationIdsChange}
                  customId="admin-location"
                />
              </div>
            ) : (
              <div className={styles.locationsEmpty}>Lokacijų nėra</div>
            )}
          </div>
        </WithSpinner>
        <div className={styles.notificationsToggle}>
          <Toggle
            checked={locationEmailNotificationEnabled}
            onChange={onLocationNotificationChange}
          />
          <span className={styles.notificationsLabel}>
            Siųsti gedimo pranešimus
          </span>
        </div>
        <div className={styles.notificationsToggle}>
          <Toggle
            checked={locationSmsNotificationEnabled}
            onChange={onLocationSmsNotificationChange}
          />
          <span className={styles.notificationsLabel}>
            Siųsti gedimo SMS pranešimus
          </span>
        </div>
      </div>
    );
  };

  const renderPermissions = () =>
    permissionDefinitions.map(permission => {
      const checked = isPermissionSelected(selectedPermissions, permission);

      return (
        <div className={styles.permissionItem} key={permission.key}>
          <Checkbox
            label={permission.label}
            name={permission.key}
            checked={checked}
            value={permission.key}
            onChange={({ target: { checked } }) =>
              onPermissionChange(permission, checked)
            }
            dense={true}
          />
          {permission.supportsLocationScope &&
            checked &&
            renderLocationAccess()}
        </div>
      );
    });

  return (
    <form className={styles.form} onSubmit={onSubmit} method="POST">
      <div className={styles.formdata}>
        <div className={styles.inputsContainer}>
          <div className={styles.inputs}>
            <Input
              name="first_name"
              label="Vardas"
              type="text"
              onChange={onChange}
              value={values.first_name}
            />
            <Input
              name="last_name"
              label="Pavardė"
              type="text"
              onChange={onChange}
              value={values.last_name}
            />
            <Input
              name="email"
              label="El. paštas"
              type="email"
              onChange={onChange}
              value={values.email}
              disabled={type === 'edit' ? true : false}
            />
            <Input
              name="phone"
              label="Tel. Numeris"
              type="text"
              onChange={onChange}
              value={values.phone}
            />
            <div className={styles.businessRoleSelect}>
              <Select
                name="business_role"
                label="Rolė"
                options={businessRoles}
                selectedValue={values.business_role}
                onChange={onChange}
                labelContainerClassName={styles.businessRoleLabel}
              />
            </div>
          </div>
        </div>
        <div className={styles.permissions}>
          <h4 className={styles.permissionsLabel}>Leidimai</h4>
          <div className={styles.permissionsList}>
            <div className={styles.permissionsSelectAll}>
              <Checkbox
                label="Žymėti visus"
                name="permissions-select-all"
                checked={areAllPermissionsSelected(
                  selectedPermissions,
                  permissionDefinitions
                )}
                onChange={onSelectAllPermissions}
                dense={true}
              />
            </div>
            {renderPermissions()}
          </div>
        </div>
      </div>

      <SubmitActions back={config.APP_PATHS.admins} loading={loading} />
    </form>
  );
};

Form.propTypes = {
  type: PropTypes.oneOf(['add', 'edit']).isRequired,
  values: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    email: PropTypes.string,
    phone: PropTypes.string,
    business_role: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  permissionDefinitions: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedPermissions: PropTypes.arrayOf(PropTypes.number).isRequired,
  onPermissionChange: PropTypes.func.isRequired,
  onSelectAllPermissions: PropTypes.func.isRequired,
  assignableLocations: PropTypes.arrayOf(PropTypes.object).isRequired,
  assignableLocationsLoading: PropTypes.bool.isRequired,
  selectedLocationIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  allLocationsSelected: PropTypes.bool.isRequired,
  onLocationIdsChange: PropTypes.func.isRequired,
  locationEmailNotificationEnabled: PropTypes.bool.isRequired,
  onLocationNotificationChange: PropTypes.func.isRequired,
  locationSmsNotificationEnabled: PropTypes.bool.isRequired,
  onLocationSmsNotificationChange: PropTypes.func.isRequired,
};

export default Form;
